import { Trash, View } from "@/assets/icons";
import { DocumentPreviewDrawer, FileItem } from "@/components";
import { Column } from "@/components/column";
import { FileListProps } from "@/components/file-list/types";
import { IconButton } from "@/components/icon-button";
import { Panel } from "@/components/panel";
import { Row, RowSize } from "@/components/row";
import { NO_VALUE } from "@/constants";
import { DrawerParams } from "@/constants/drawer";
import { getNormalizedFileName } from "@/utils";
import { compact, isArray, map, noop } from "lodash";
import { FC } from "react";
import { useSearchParams } from "react-router-dom";
import styles from "./styles.scss";

export const FileList: FC<FileListProps> = ({
  file,
  fileName,
  fileFormat,
  fileId,
  onRemove,
  disabled,
  fileItemNameClassName,
}) => {
  const _files = isArray(file) ? file : [file];
  const [searchParams, setSearchParams] = useSearchParams();

  const handlePreview = () => {
    const newQueryParameters: URLSearchParams = new URLSearchParams(
      searchParams,
    );

    newQueryParameters.set(DrawerParams.DRAWER_SEARCH_PARAM, fileName);
    newQueryParameters.set(DrawerParams.DRAWER_DOC_ID, fileId);
    newQueryParameters.set(DrawerParams.DOC, "ContractorTradeLisense");

    setSearchParams(newQueryParameters);
  };

  return (
    <>
      <DocumentPreviewDrawer
        doc={_files[0] as unknown as string | null | undefined}
      />

      {map(compact(_files), (file, i) => {
        return (
          <Row size={RowSize.Small} key={i} className={styles.fileOuter}>
            <Column>
              <Panel>
                <div className={styles.fileInner}>
                  <FileItem
                    fileItemNameClassName={fileItemNameClassName}
                    disabled={disabled}
                    extension={fileFormat}
                    fileName={
                      fileName ? getNormalizedFileName(fileName) : NO_VALUE
                    }
                  />
                  <div className={styles.iconContainerWrapper}>
                    <IconButton
                      disabled={disabled}
                      icon={View}
                      className={styles.iconContainer}
                      onClick={() => (disabled ? noop : handlePreview())}
                    />
                    <IconButton
                      disabled={disabled}
                      icon={Trash}
                      className={styles.iconContainer}
                      onClick={() => (disabled ? noop : onRemove(file?.id))}
                    />
                  </div>
                </div>
              </Panel>
            </Column>
          </Row>
        );
      })}
    </>
  );
};
